import { Children, Fragment, isValidElement } from 'react';
import { Menu, MenuButton, IconButton } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { MenuList } from '@/components/v4';
import style from '../styles';

const DashboardCardEditButton = ({
    children,
    dataWalkthroughId,
    id,
    onMenuOpen,
}) => {
    const { darkMode } = useSelector((state) => state.settings);
    const textColor = darkMode ? 'white' : 'black';
    const { actionButton } = style;

    const hasChildren =
        children &&
        Children.toArray(children).some((child) => {
            return isValidElement(child);
        });

    return hasChildren ? (
        <Menu
            key="3-dot-menu"
            id={id}
            strategy="fixed"
            placement="start"
            onOpen={onMenuOpen}>
            {() => (
                <Fragment key="3-dot-menu-wrapper">
                    <MenuButton
                        id={id}
                        sx={actionButton}
                        as={IconButton}
                        aria-label="Options"
                        icon={<BsThreeDotsVertical />}
                        variant="outline"
                        color={textColor}
                        _active={{
                            bg: darkMode
                                ? 'rgba(255, 255, 255, 0.16)'
                                : 'gray.200',
                        }}
                        data-walkthroughid={`/dashboard-services/card/${dataWalkthroughId}`}
                    />
                    <MenuList zIndex={1000}>{children}</MenuList>
                </Fragment>
            )}
        </Menu>
    ) : null;
};

export default DashboardCardEditButton;
